export const showTutorial = (state: boolean) => state

export const clearHomeTutorial = () => true
